import { EventHandler, SyntheticEvent } from 'react';

export function teeEvent<E extends SyntheticEvent<HTMLInputElement | HTMLTextAreaElement | HTMLButtonElement>>(
  callback: EventHandler<E>,
  ...callbacks: EventHandler<E>[]
) {
  return (event: E): void => {
    if (callback) {
      callback(event);
    }

    if (!event.defaultPrevented) {
      callbacks.forEach((callback) => (callback ? callback(event) : null));
    }
  };
}
